import { Component, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { Globals } from '../../../globals';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ConfirmationDialog } from '../../ConfirmationDialog';
import { AuthService } from '../../../API/auth.service';
import { QuickAddPartDialog } from '../../QuickAddPart/QuickAddPartDialog';
import { AppComponent } from 'src/app/app.component';
import { InvApiService } from 'src/app/API/invapi.service';
import { PartsInventoryComponent } from '../PartsInventoryComponent/PartsInventoryComponent';
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'Parts_Component',
  templateUrl: './PartsComponent.html'
})

export class PartsComponent {

  quickAddDialogRef: MatDialogRef<QuickAddPartDialog>;
  dialogRef: MatDialogRef<ConfirmationDialog>;
  today = new Date();
  public PrevParts = [];
  PartDescription = '';
  PartSearchTerm = '';
  PartAutoComplete = 'test';
  PartSelectedItem = <any>{};
  public PartTrans = [];
  PartQuantity = '0';
  PartCost = 0;
  PartQtyList = [];
  SelectedPart;
  public partSearchResult = [];
  public SelectedDialysisUnits;
  public SelectedEquipment
  public partscategoryname:string= 'Dialysis Machines';
  public currentUserId;
  public API;
  public status;
  public showPartHearder=true;
  public disableControl =false;
  public divisionId = 0;
  public questionId;
  inventoryControlFlag = false;
  public isAddUpdateQty=false;
  @Output() deletePartClick = new EventEmitter<boolean>();

  @Output()
  RaiseError = new EventEmitter();

  // @ViewChild(PartsComponent) partsComp: PartsComponent;
// @Input() public PrevPartsTemp: any[] = [];
  constructor(
    public dialog: MatDialog,
    private auth: AuthService,
    private invapi: InvApiService,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit() {

    // this.auth.GetCurrentDateTimeFromServer().subscribe(currentDate => {
    //   this.today = new Date(currentDate);
    //   while (this.PartQtyList.length < 10) {
    //     this.PartQtyList.push({
    //       text: (this.PartQtyList.length + 1).toString(),
    //       value: (this.PartQtyList.length + 1).toString()
    //     });
    //   }
    //   this.PartQuantity = '1';
    // }, error => {
    // });

  //    if (this.PrevPartsTemp && this.PrevPartsTemp.length > 0) {
  //   this.PrevParts = [...this.PrevPartsTemp];   // or PartTrans instead
  // }

    const isInventoryControls = JSON.parse(sessionStorage.getItem('IsInventoryControls') || 'false');
    this.inventoryControlFlag = isInventoryControls;

    this.auth.GetCurrentDateTimeFromServer().subscribe(currentDate => {
    this.today = new Date(currentDate);
    this.PartQtyList = []; // reset on load
    this.PartQuantity = '0';
    }, error => {
    });

     // this.PartTrans = [...this.PartTrans, ...this.PrevPartsTemp];
  }

  PartCodeChange(type) {

    const dmrepairCreate = <any>{};
    dmrepairCreate.partsSearchtext = this.PartSearchTerm;
   // console.log(this.f.PartSearchTerm.value);
    dmrepairCreate.divisionId = this.SelectedDialysisUnits;
    dmrepairCreate.equipementId = this.SelectedEquipment;
    this.partSearchResult = [];
    const obj = {
      partssearchtext: this.PartSearchTerm,
      partscategoryname: this.partscategoryname,
      partsserachtype: type,
      partsshowinventory: true,
      divisionid: this.SelectedDialysisUnits,
      equipementid: this.SelectedEquipment,
    };
    if (type === 'desc') {
      obj.partssearchtext = this.PartDescription;
    }
    this.API.GetPartsdetailsDetailssearchByCategory(obj).subscribe(list => {
      console.log('GetPartsdetailsDetailssearchByCategory ???????'+obj);
      this.divisionId = obj.divisionid;
      this.partSearchResult = list;
    });
    
  }

  getPartPosts(option, type) {
    if(option && option.value){
        if (type === 'code') {
          this.PartSelectedItem = this.partSearchResult.filter(
            x => x.equipmentcode === option.value
          )[0];
          this.PartDescription = this.PartSelectedItem.equipmentDesc;
        } else {
          this.PartSelectedItem = this.partSearchResult.filter(
            x => x.equipmentDesc === option.value
          )[0]; 
          this.PartSearchTerm = this.PartSelectedItem.equipmentcode;
        }
        this.SetCost();

        this.auth.GetCurrentDateTimeFromServer().subscribe(currentDate => {
          this.today = new Date(currentDate);
        });

        this.isAddUpdateQty = true;
        const model = { partID: this.PartSelectedItem.equipementid, divisionID: this.divisionId };
        this.PartQtyList = [];
        
         this.invapi.GetPartsQuantityByDivisionID(model).subscribe({
            next: (success: any) => {
              let availableQty = 0;

              if (success && success.qty != null) {
                if (this.inventoryControlFlag) {
                  if (this.PartTrans.length > 0) {
                     // const selectedPart = this.PartTrans.filter(c => c.equipmentId == this.PartSelectedItem.equipementid);
                    // availableQty = selectedPart.reduce((sum, item) => sum + item.quantity, 0);

                    // Apply logic only for DMRepairDetailsId == 0
                    const selectedPart = this.PartTrans.filter(c =>
                        c.equipmentId == this.PartSelectedItem.equipementid &&
                        (c.DMRepairDetailsId == 0 || c.RepairDetailsId == 0)
                      );

                    availableQty = selectedPart.reduce((sum, item) => sum + item.quantity, 0);
                  }

                  success.qty = success.qty - availableQty;
                }

                this.PartQtyList = [];

                if (success.qty > 0) {
                  // Populate dropdown from 1 to available qty
                  for (let i = 1; i <= success.qty; i++) {
                    this.PartQtyList.push({ text: i.toString(), value: i.toString() });
                  }
                  // ✅ Select first available value (1)
                  this.PartQuantity = this.PartQtyList[0].value;
                } else {
                  // ✅ No quantity — show and select 0
                  this.PartQtyList.push({ text: '0', value: '0' });
                  this.PartQuantity = '0';
                }

              } else {
                // If API didn't return valid qty (null or missing)
                this.PartQtyList = [{ text: '0', value: '0' }];
                this.PartQuantity = '0';
              }

              // Recalculate cost every time
              this.SetCost();
              AppComponent.HideLoader();
            },
            error: () => {
              // In case of error, set safe defaults
              this.PartQtyList = [{ text: '0', value: '0' }];
              this.PartQuantity = '0';
              this.SetCost();
              AppComponent.HideLoader();
            }
          });
    }
  }

  SetCost() {
    if (this.PartQuantity !== '' && this.PartSelectedItem !== undefined) {
      // tslint:disable-next-line:radix
      this.PartCost = parseInt(this.PartQuantity) * this.PartSelectedItem.itemcost;
       // console.log(this.PartCost);
    }
  }

  AddNewPartInventory(){
    if(this.SelectedEquipment){
        this.PartSelectedItem.desc = '';
        const isMobile = this.breakpointObserver.isMatched(Breakpoints.Handset);
        this.quickAddDialogRef = this.dialog.open(QuickAddPartDialog, {
          disableClose: true,
          position: { right: '0',top:'0'},
          height: '100%',
          //maxWidth:'60vh',
          width: isMobile ? '100vw' : '60%',
          maxWidth: isMobile ? '40vw' : '60vh',
          maxHeight: '100vh',
          data: {
            category: this.partscategoryname,
            comp_equipmentId:  this.SelectedEquipment
          }
        });
        //this.quickAddDialogRef.componentInstance.quickAddPartModel.title = type;
        this.quickAddDialogRef.afterClosed().subscribe(result => {
        });

        this.quickAddDialogRef.componentInstance.SaveEvent.subscribe(evt => {
            this.PartSelectedItem = evt;
            this.PartDescription = this.PartSelectedItem.equipmentDesc;
            this.PartSearchTerm = this.PartSelectedItem.equipmentcode;
            this.SetCost();
        });
    }
    else{
      AppComponent.addAlert(Globals.FormErrorMessage, "error");
    }
  }

  AddPart() {
    if (
      this.PartSelectedItem.equipementid != null &&
      this.PartSelectedItem.equipementid > 0 && this.PartQuantity != '0'
    ) {
        const obj = <any>{};
        obj.DMRepairDetailsId = 0;
        obj.equipmentId = this.PartSelectedItem.equipementid;
        // tslint:disable-next-line:radix
        obj.quantity = parseInt(this.PartQuantity);
        // obj.quantity = this.PartQuantity;
        obj.PartCode = this.PartSelectedItem.equipmentcode;
        obj.PartDescription = this.PartSelectedItem.equipmentDesc;
        obj.PartCost = this.PartSelectedItem.itemcost;

        obj.createdBy = this.currentUserId;
        obj.createdByName = this.auth.GetUserFLName();
        obj.createdOnDisplay = this.today;
        obj.createdOn = Globals.GetAPIDate(this.today);
        obj.modifiedBy = this.currentUserId;
        obj.modifiedOnDisplay = this.today;
        obj.modifiedOn = Globals.GetAPIDate(this.today);

        // For Repair Detail Parts Table
        obj.repairPartDetailsEnteredBy = this.currentUserId;
        obj.repairPartDetailsEnteredOn = Globals.GetAPIDate(this.today);
        obj.partName = this.PartSelectedItem.equipmentcode;
        obj.totalCost = this.PartSelectedItem.itemcost;

        obj.showPartDelete = false;
        if (obj.createdBy === this.currentUserId) {
          obj.showPartDelete = true;
        }
        obj.questionId = this.questionId;
        this.PartTrans.push(obj);

        this.PartSearchTerm = '';
        this.PartSelectedItem.desc = '';
        this.PartDescription ='';
        // this.PartLocation = "";
        this.PartCost = 0;
        this.PartQuantity = '1';
        this.partSearchResult = [];
        this.PartQtyList = [];
        this.PartSelectedItem =<any>{};
        this.isAddUpdateQty = false;
  //    }
    }
  }

  DeletePart(index) {
      this.dialogRef = this.dialog.open(ConfirmationDialog, {
        disableClose: true
      });
      this.dialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
        this.dialogRef.afterClosed().subscribe(result => {
          if (result) {
            const deletedPart = this.PartTrans[index];   
            this.PartTrans.splice(index, 1);
            if (deletedPart && deletedPart.DMRepairDetailsId !== 0) {
              this.deletePartClick.emit(deletedPart);
            }
          }
          this.dialogRef = null;
        });

        this.PartSearchTerm = '';
        this.PartSelectedItem.desc = '';
        this.PartDescription ='';
        this.PartCost = 0;
        this.PartQuantity = '1';
        this.partSearchResult = [];
        this.PartQtyList = [];
        this.PartSelectedItem =<any>{};
        this.isAddUpdateQty = false;
    }

  adjustAutocompleteWidth(): void {
    setTimeout(() => {
      const panel = document.querySelector('.cdk-overlay-pane') as HTMLElement;
      if (panel) {
        // panel.style.minWidth = '600px'; // or use '100%' or match your input width
        // panel.style.maxWidth = 'none';
        // panel.style.width = 'auto';
        // panel.style.whiteSpace = 'nowrap'; // prevent wrapping
      }
    }, 0); // delay until after Angular renders the overlay
}

 onPartCodeFocus(): void {
    // Wait for DOM to update then adjust width
    setTimeout(() => {
      this.adjustAutocompleteWidth();
      this.PartCodeChange("code"); // Initialze all parts when click on input area
    }, 100); // ensure overlay has rendered
  }

  onPartCodeKeyup(): void {
    this.adjustAutocompleteWidth();
    this.PartCodeChange("code");
  }

  openInventory() {
    const dialogRef =  this.dialog.open(PartsInventoryComponent, {
      disableClose: true,
      position: { right: '0', top: '0' },
      height: '100%',
      width:  '120%',
      maxWidth:  '180vh' ,
      data: { equipementid: this.PartSelectedItem.equipementid, equipmentcode : this.PartSelectedItem.equipmentcode,
              equipmentDesc: this.PartSelectedItem.equipmentDesc, divisionId: this.divisionId,
              isDialogFromPartsComponent: true }
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Dialog closed with result:', result);
      if (result) {
        this.PartQuantity = result.partQuantity;

        this.SetCost();

        if(this.inventoryControlFlag)
        {
            let availableQty = 0;
            // if(this.PartTrans.length > 0)
            // {
            //   const selectedPart =  this.PartTrans.filter(c=> c.equipmentId == this.PartSelectedItem.equipementid);
            //   availableQty = selectedPart.reduce((sum, item) => sum + item.quantity, 0);
            // }
            //   result.partQuantity = result.partQuantity - availableQty;
              if (this.PartTrans.length > 0) {
                    const selectedPart = this.PartTrans.filter(c =>
                        c.equipmentId == this.PartSelectedItem.equipementid &&
                        (c.DMRepairDetailsId == 0 || c.RepairDetailsId == 0)
                      );

                    availableQty = selectedPart.reduce((sum, item) => sum + item.quantity, 0);
                  }

                  result.partQuantity = result.partQuantity - availableQty;
          }

         this.PartQtyList = [];
                for (let i = 1; i <= result.partQuantity; i++) {
                  this.PartQtyList.push({ text: i.toString(), value: i.toString() });
                } 
                
      } else {
        console.log('No data returned');
      }
    });
  }

  // helper: call the API and rebuild PartQtyList taking current PartTrans allocations into account
   
}


